/**
 * Splits a string accessor to a path through the object.
 * @internal
 */
export function splitAccessorPath(accessor: string): string[] {
  let nestingLevel = 0;
  let lastTokenIndex = 0;
  const accessPath: string[] = [];

  for (let i = 0; i < accessor.length; i += 1) {
    const currentChar = accessor.at(i);

    // Encountered a token separator. These can either be separated by `.`
    if (currentChar === '.' && nestingLevel === 0) {
      // Push the token to the accessPath.
      accessPath.push(accessor.slice(lastTokenIndex, i));

      // Move the lastTokenIndex to the start of the group, from
      // stringaccessor.other
      // here          ^|
      // there          ^
      lastTokenIndex = i + 1;
      continue;
    }

    // Opening group
    if (
      currentChar === '[' &&
      (accessor.at(i + 1) === '"' || accessor.at(i + 1) === "'")
    ) {
      // If the character before is not a '.' and it's not the immediate start of the string
      // slice in the start
      if ((accessor.at(i - 1) !== '.' || i === 0) && lastTokenIndex !== i) {
        accessPath.push(accessor.slice(lastTokenIndex, i));
      }

      // Increase the group nesting level to know that the parser is currently
      // in a group context.
      nestingLevel += 1;
      // Move the lastTokenIndex to the start of the group, from
      // stringaccessor.["some"]
      // here           ^ |
      // there            ^
      lastTokenIndex = i + 2;
      // Move the loop index along as well, but -1 as it will be increased in the next
      // loop as well.
      i += 1;
      continue;
    }

    // Closing group
    if (
      (currentChar === '"' || currentChar === "'") &&
      accessor.at(i + 1) === ']'
    ) {
      // Decrease the group nesting level to know that the current group was exited.
      nestingLevel -= 1;
      accessPath.push(accessor.slice(lastTokenIndex, i));
      // Move the lastTokenIndex to the start of the group, from
      // stringaccessor.["some"].simple
      // here                 ^  |
      // there                   ^
      lastTokenIndex = i + 3;
      // Move the loop index along as well, but -1 as it will be increased in the next
      // loop as well.
      i += 2;
      continue;
    }

    if (i === accessor.length - 1 && lastTokenIndex < accessor.length - 1) {
      accessPath.push(accessor.slice(lastTokenIndex, i + 1));
    }
  }

  return accessPath;
}
